import React from 'react'

import { AppContainer } from 'core'
import LayoutComponent from 'core/components/LayoutComponent'

import LoginPage from './pages/LoginPage'

export default (props) => {
  return (
    <AppContainer {...props}>
      <LayoutComponent theme='clean-centered' isLogin={true}>
        <LoginPage />
      </LayoutComponent>
    </AppContainer>
  )
}
